import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import LoadingSpinner from './components/LoadingSpinner';
import NoAccessNotice from './components/NoAccessNotice';

const API_BASE = process.env.REACT_APP_API_URL;

export default function BuildOrderArchivePage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user, isSignedIn } = useUser();
  const role = user?.publicMetadata?.role || 'guest';
  const isAdmin = role === 'admin';
  const isService = String(role).toLowerCase().startsWith('service');

  useEffect(() => {
    if (!isAdmin && !isService) return;
    setLoading(true);
    fetch(`${API_BASE}/build-order-archive`)
      .then(res => res.json())
      .then(setOrders)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [isAdmin, isService]);

  if (!isSignedIn || (!isAdmin && !isService)) {
    return (
      <div className="ni-page">
        <div className="ni-shell ni-shell--narrow">
          <NoAccessNotice pageName="the build order archive" />
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="ni-page">
        <div className="ni-shell ni-shell--narrow">
          <div className="ni-panel" style={loadingStyle}>
            <LoadingSpinner size={64} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="ni-page">
      <div className="ni-shell ni-shell--narrow">
        <header className="ni-header">
          <div className="ni-brand">
            <Link to="/" title="Back to main page" aria-label="Back to main page" style={{ display: 'inline-flex', lineHeight: 0 }}>
              <img src="/north-invent-logo.svg" alt="North Invent" className="ni-brand-logo" />
            </Link>
            <div className="ni-brand-copy">
              <span className="ni-eyebrow">Archive</span>
              <span className="ni-brand-subtitle">Archived build orders</span>
            </div>
          </div>
        </header>
        {orders.length === 0 ? (
          <div className="ni-panel ni-empty">No archived build orders found.</div>
        ) : (
          <div className="ni-grid">
            {orders.map(o => (
              <div key={o._id} className="ni-panel">
                <p><strong>Order:</strong> {o.orderNumber}</p>
                <p><strong>Product:</strong> {o.product}</p>
                <p><strong>Quantity:</strong> {o.quantity}</p>
                {o.dueDate && (
                  <p><strong>Ready By:</strong> {new Date(o.dueDate).toLocaleDateString()}</p>
                )}
                <p><strong>Archived:</strong> {new Date(o.archivedAt).toLocaleDateString()}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const loadingStyle = {
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
